import qs from 'qs';
import repuest from './repuest';
import Data from '../data';
import Const from '../const';

class Net {
  static PROTOCOL = window.location.protocol + "//"
  static OSS_POINT = ""
  static END_POINT = ""

  /** 获取请求接口地址 */
  static getEndPoint() {
    return new Promise((resolve) => {
      if (Net.END_POINT) {
        resolve(Net.END_POINT)
      } else {
        const VUE_APP_API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT
        const urlMap = {
          development: VUE_APP_API_ENDPOINT || Const.NET.URL_POINT_DEV,
          production: VUE_APP_API_ENDPOINT || Const.NET.URL_POINT,
        }
        const baseUrl = urlMap[process.env.NODE_ENV] || urlMap.production
        Net.END_POINT = baseUrl.replace(/^https?:\/\//, '')
        resolve(baseUrl)
      }
    })
  }
  /** 文件上传接口 */
  static get FILE_UPLOAD() {
    return Net.PROTOCOL + `${Net.END_POINT}/file/file-upload`
  }
  /** 图片上传接口 */
  static get IMG_UPLOAD() {
    return Net.PROTOCOL + `${Net.END_POINT}/file/img-upload`
  }
  /** 文件前缀 */
  static get FILE_PREFIX() {
    return Net.OSS_POINT + "/file/"
  }

    /** 接口版本标记 */
  static versionMark = "/1"
  constructor(mark = '/1') {
    Net.versionMark = mark
    Net.getEndPoint()
  }

  /** 剔除多余 "/"  */
  static eliminateSprit(url) {
    return url.split('/').filter(i => i).join('/')
  }
  /** Object 转 链接 */
  static stringify(obj) {
    let p = [];
    for (let key in obj) {
      p.push(encodeURIComponent(key) + '=' + encodeURIComponent(Net.valueWithDef(obj[key])));
    }
    return p.join('&');
  }
  /** 空值处理 */
  static valueWithDef(val) {
    if (typeof val === 'undefined' || val === null || val === '') {
      return ''
    }
    return val
  }
  /** 判断 数组arr的index项 是否是有效的对象 */
  static isObject(arr, index) {
    if (arr && Array.isArray(arr) && arr.length >= (index + 1)) {
      let item = arr[index]
      if (item && Object.getPrototypeOf(item) === Object.prototype) {
        return true
      }
    }
    return false
  }
  /** 判断 传入的值是否为空值(null/undefined) */
  static isEmpty(val) {
    return val == null || val == undefined
  }

  /** 用户身份标记；Notify/Common 免角色前缀、免 token */
  static getRoleMark(moduleName) {
    const noMark = ['Notify', 'Common'];
    if (moduleName && noMark.includes(moduleName)) { return '' }

    const LOGIN_TYPE = Const.LOGIN_TYPE;
    const loginType = Data.getLoginType();
    let mark = 'operator';
    switch (loginType) {
      case LOGIN_TYPE.ADMIN: mark = 'admin'; break;
      case LOGIN_TYPE.ADMIN_MEMBER: mark = 'admin'; break;
      case LOGIN_TYPE.OPERATOR: mark = 'operator'; break;
      case LOGIN_TYPE.OPERATOR_MEMBER: mark = 'operator'; break;
      case LOGIN_TYPE.CLEARING_ACCOUNT: mark = 'clearing-account'; break;
    }
    return mark
  }

  /** 根据配置文件调用接口（声明式配置入口）
   * @param {Array} config [方法名, 接口名, 参数1, 参数2, ...]
   * @param {String} moduleName 模块名称
   * @param {String} functionName 方法名称
   * @param {Any} args
   */
  async httpBatch(config, moduleName, functionName, ...args) {
    const roleMark = Net.getRoleMark(moduleName)
    const mark = roleMark ? roleMark + Net.versionMark : ''

    const apiName = config[1];
    const params = config.slice(2);
    const form = {};
    let postConfig = null;
    if (roleMark) { form.token = Data.getToken(); }

    const fullUrl = Net.PROTOCOL + Net.eliminateSprit(`${Net.END_POINT}/${mark}/${apiName}`)

    if (Net.isObject(args, 0)) {
      // 有参数 且第一个参数为对象 -> 新的传参方式 直接合并到 form上
      Object.assign(form, args[0]);
      if (Net.isObject(args, 1)) {
        postConfig = args[1]
      }
      for (const key in form) {
        // 去掉空值
        if (Net.isEmpty(form[key])) { form[key] = ''; }
      }
    } else {
      // 传统传参方式 -> 通过循环config[2,len] 将参数设置到 form上
      for (let i = 0; i < params.length; i++) {
        form[params[i]] = Net.isEmpty(args[i]) ? '' : args[i];
      }
    }

    console.log(`%c ${apiName} => ${fullUrl}?${Net.stringify(form)}`, 'color:#006CFF;background:#006cff2a;');

    switch (config[0]) {
      case 'Export':
        return fullUrl + '?' + Net.stringify(form)
      case 'PostJson':
        return repuest({
          headers: { 'Content-Type': 'application/json' },
          method: 'post',
          url: fullUrl,
          params: { token: form.token },
          data: form,
          ...postConfig,
        })
      case 'Post':
        return repuest.post(fullUrl, qs.stringify(form), postConfig);
      case 'Get':
        return repuest({
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          method: 'get',
          url: fullUrl,
          params: form,
          ...postConfig,
        })
      case 'Put':
        return repuest({
          headers: { 'Content-Type': 'application/json' },
          method: 'put',
          url: fullUrl,
          params: form,
          ...postConfig,
        })
    }
  }

  /** 单独调用接口（显式函数式 module 入口）
   * @param {String} url 请求地址
   * @param {Object} q   请求参数
   * @param {Object} q.data 请求参数
   * @param {String} q.method 请求方式
   * @param {Object} q.config 其他请求配置
   * @param {String} q.roleMark 角色标记（传空串表示免角色前缀、免 token）
   * @param {String} q.versionMark 版本标记
   */
  static async http(url, q = {}) {
    let { data = {}, method = 'POST', config = null, roleMark = '', versionMark = '' } = q


    roleMark = roleMark || Net.getRoleMark()
    versionMark = versionMark || Net.versionMark
    method = method.toUpperCase();

    let fullUrl = url
    /** 非完整接口地址 拼接接口地址 */
    if (!url.includes('http') && !url.includes('/api/')) {
      fullUrl = Net.PROTOCOL + Net.eliminateSprit(`${Net.END_POINT}/${roleMark}/${versionMark}/${url}`)
    }

    const form = {}
    if (roleMark) { form.token = Data.getToken(); }
    for (const key in data) {
      form[key] = Net.isEmpty(data[key]) ? '' : data[key];
    }

    console.log(`%c ${url} => ${fullUrl}?${Net.stringify(form)} `, 'color:#006DFF;background:#006DFF2a')

    switch (method) {
      case 'POSTJSON':
        return repuest({
          headers: { 'Content-Type': 'application/json' },
          method: 'post',
          url: fullUrl,
          params: { token: form.token },
          data: form,
          ...config,
        })
      case 'POST':
        return repuest.post(fullUrl, qs.stringify(form), config)
      case 'GET':
        return repuest({
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          method: 'get',
          url: fullUrl,
          params: form,
          ...config,
        })
      default:
        break;
    }
  }
}

class Api extends Net {
  constructor(apiList, mark = '/1') {
    super(mark);
    for (const moduleName in apiList) {
      this[moduleName] = Object.create(null);
      const module = apiList[moduleName];
      for (const functionName in module) {
        const config = module[functionName];
        this[moduleName][functionName] = ((config) => {
          return (...args) => {
            return this.httpBatch(config, moduleName, functionName, ...args);
          };
        })(config);
      }
    }
  }
}

export default Net;
export { Api };
